/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetConnectRssIcon20Solid = forwardRef('NetConnectRssIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8.336 6.372A9.25 9.25 0 0 0 4.56 5.76a1.25 1.25 0 0 1-.12-2.497A11.75 11.75 0 0 1 16.738 15.56a1.25 1.25 0 1 1-2.497-.119 9.251 9.251 0 0 0-5.904-9.069Z" }),
        React.createElement("path", { d: "M6.446 11.004a4.25 4.25 0 0 0-1.833-.236 1.25 1.25 0 1 1-.227-2.49 6.75 6.75 0 0 1 7.336 7.336 1.25 1.25 0 0 1-2.49-.228 4.25 4.25 0 0 0-2.786-4.382Z" }),
        React.createElement("path", { d: "M5 16.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z" })));
});
